import { render, staticRenderFns } from "./ModulesAdmin.vue?vue&type=template&id=49644aa4"
import script from "./ModulesAdmin.vue?vue&type=script&lang=js"
export * from "./ModulesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports